import React from "react"
import { Table } from "react-bootstrap"

import { fieldLabel } from "@/onboarding/features/product/models/fieldLabels"

import { flagLabel } from "@/onboarding/features/bidding/flagOptions"
import { changedTours, tourPermissionValue } from "@/onboarding/features/bidding/models/fieldStates"
import tourLabel from "@/onboarding/features/bidding/models/tourLabel"
import {
  PendingFieldPermissionChange,
  TourFieldPermissions,
} from "@/onboarding/features/bidding/types"

type Props = {
  change: PendingFieldPermissionChange
  tours: TourFieldPermissions[]
}

const PendingFieldPermissionChangeSummary = ({ change, tours }: Props): JSX.Element => {
  const { fieldName, permissionFlag, pickedPermissionValue } = change
  const changed = changedTours(tours, fieldName, permissionFlag, pickedPermissionValue)
  const unchanged = tours.filter((tour) => !changed.includes(tour))

  const currentLabel = (tour: TourFieldPermissions) => {
    const value = tourPermissionValue(tour, fieldName, permissionFlag)

    if (value === undefined) {
      return "Mixed"
    }

    return flagLabel(permissionFlag, value)
  }

  return (
    <section className="d-flex flex-column gap-2">
      <h3 className="h6 mb-0">
        {fieldLabel(fieldName)}: {flagLabel(permissionFlag, pickedPermissionValue)}
      </h3>
      <p className="small text-muted mb-0">
        {changed.length} of {tours.length} selected tours will change
      </p>
      {changed.length > 0 && (
        <Table size="sm" className="mb-0">
          <thead>
            <tr>
              <th scope="col">Will change</th>
              <th scope="col">Now</th>
              <th scope="col">After submit</th>
            </tr>
          </thead>
          <tbody>
            {changed.map((tour) => (
              <tr key={tour.tourId}>
                <td>{tourLabel(tour)}</td>
                <td>{currentLabel(tour)}</td>
                <td className="fw-semibold">{flagLabel(permissionFlag, pickedPermissionValue)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      {unchanged.length > 0 && (
        <p className="small mb-0">
          Already {flagLabel(permissionFlag, pickedPermissionValue).toLowerCase()}, no change:{" "}
          {unchanged.map(tourLabel).join(", ")}
        </p>
      )}
    </section>
  )
}

export default PendingFieldPermissionChangeSummary
